import { v4 as uuidv4 } from 'uuid';

export const institutionIdsProd = [
  '69971820073204998', // chase
  '69971807305743617', // american express
  '408181699099222785', // fidelity inv and retirement
  '92122059351475713', // capital one
  '69971811382607105', // bank of america
  '69971820777848065', // citibank
  '69971876109106438', // wells fargo
  '298122832534442497', // charles schwab
  '69971875001810177', // vanguard
  '69971827287407875', // discover credit card
  '69971805946789122', // ally bank
  '176196033634893056', // robinhood
  '69971872703331591', // us bank
  // '69971818076716294', // capital one card services
  '69971874548825352', // usaa
  '83748603123680768', // venmo
  '319457069652701955', // paypal
  // '69971827287407874', // discover card
  '69971859382222089', // e*trade investments
  '181124510166614016', // sofi
  '69971814654164226', // barclays bank delaware
  // '400011379693152513', // fidelity investments
];

export const institutionIdsStg = [
  '70582539956977154', // chase
  '70582526333877761', // american express
  // '431881833764419072', // fidelity inv and retirement
  '231674199594885639', // capital one
  '70582530444295687', // bank of america
  '275493326121617152', // citibank
  '231674209896096260', // wells fargo
  '70582539873091080', // charles schwab
  // 'xxx', // vanguard
  '70582548949564934', // discover credit card
  // 'xxx', // ally bank
  '206531276377000960', // robinhood
  '70582604968689153', // us bank
  // 'xxx', // capital one card services
  '246199127580894464', // usaa
  // 'xxx', // venmo
  // 'xxx', // paypal
  // 'xxx', // discover card
  // 'xxx', // e*trade investments
  // 'xxx', // sofi
  // 'xxx', // barclays bank delaware
  // 'xxx', // fidelity investments
];

const institutionMaps: Record<any, string[]> = {
  prod: institutionIdsProd,
  stg: institutionIdsStg,
};

const baseInstitutionLogin = () => ({
  clientId: uuidv4(),
  cpSetupMode: 'SKIP_ACCOUNT_DISCOVERY',
  isConnected: true,
});

const mockFIs = () => {
  const institutionIds: string[] = institutionMaps[process.env.SERVICE_ENV || 'prod'];
  return institutionIds.map((institutionId) => ({
    ...baseInstitutionLogin(),
    institutionId,
  }));
};

export default mockFIs;
